import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
export var LiveProductLinks = function LiveProductLinks() {
  return React.createElement(Fragment, null, React.createElement("li", null, React.createElement(Link, {
    to: "/live/features"
  }, React.createElement(FormattedMessage, {
    id: "header.link.live.features",
    defaultMessage: "How it works"
  }))));
};